import { Row, Box, Text, Image, Pressable } from 'native-base'
import { Fragment, useMemo } from 'react'
import { StyleSheet } from 'react-native'

import { PointsBox } from './PointsBox'
import { RemoteImage } from './RemoteImage'
import { BoxWithShadow } from './atoms'

import { theme, offerTileImgWidth, offerTileImgHeight } from '~constants'
import { OfferItem } from '~types/offer'
import { getOfferStatus } from '~utils'

type OfferTileType = {
  onPress: () => void
} & Pick<
  OfferItem,
  'buyStatus' | 'discountCode' | 'endDate' | 'image' | 'merchant' | 'offerLeft' | 'points' | 'title'
>

const IMAGE_HEIGHT = offerTileImgHeight + 'px'
const IMAGE_WIDTH = offerTileImgWidth + 'px'

export const OfferTile = ({
  buyStatus,
  discountCode,
  endDate,
  image,
  merchant: { logo: merchantLogo, name: merchantName },
  offerLeft,
  onPress,
  points,
  title,
}: OfferTileType) => {
  const status = useMemo(
    () => getOfferStatus({ buyStatus, endDate, offerLeft }),
    [buyStatus, endDate, offerLeft]
  )

  return (
    <BoxWithShadow borderRadius="lg" h={IMAGE_HEIGHT} shadowSize="l">
      <Pressable onPress={onPress}>
        <Row>
          <Box w={IMAGE_WIDTH} h={IMAGE_HEIGHT}>
            <RemoteImage alt="Product Image" resizeMode="cover" uri={image} style={styles.image} />
            <Box
              bg="transparent"
              borderBottomLeftRadius="lg"
              borderTopRightRadius="lg"
              style={styles.brandLogo}
            >
              <Image
                alt="Brand logo"
                fallbackElement={<Fragment />}
                h="full"
                source={{ uri: merchantLogo }}
                w="full"
              />
            </Box>
          </Box>

          <Box flex={1} justifyContent="space-between">
            <Row justifyContent="space-between">
              <Text color="main" flex={1} fontSize="sm" numberOfLines={1} px="4" pt="4">
                {merchantName}
              </Text>
              <PointsBox isRedeemed={!!buyStatus} points={points} code={discountCode} />
            </Row>
            <Text color="main" fontSize="md" fontWeight="700" numberOfLines={2} px="4">
              {title}
            </Text>
            <Text color="offMain" pb="4" px="4">
              {status}
            </Text>
          </Box>
        </Row>
      </Pressable>
    </BoxWithShadow>
  )
}

const { radii } = theme
const styles = StyleSheet.create({
  brandLogo: {
    bottom: 0,
    height: 48,
    overflow: 'hidden',
    position: 'absolute',
    width: 48,
  },
  image: {
    borderBottomLeftRadius: radii.lg,
    borderTopLeftRadius: radii.lg,
    flex: 1,
    height: '100%',
    width: '100%',
  },
})
